export default {
	title: 'Caso de Falla',
	selectAll: 'Seleccionar Todo',
	selectedCount: '{count} elementos seleccionados',
	batchDelete: 'Eliminar en Lote',
	batchDeleteWithCount: 'Eliminar en Lote ({count})',
	noData: {
		title: 'No Hay Casos de Falla',
		description: 'No se encontraron datos de casos de falla'
	},
	reportCard: {
		coverAlt: 'Portada de Caso de Falla',
		author: 'Autor',
		reviewer: 'Revisor',
		approver: 'Aprobador',
		updateTime: 'Tiempo de Actualización'
	},
	status: {
		completed: 'Completado',
		editing: 'Editando'
	},
	actions: {
		generateReport: 'Generar Informe',
		download: 'Descargar',
		delete: 'Eliminar',
		edit: 'Editar',
		batchDelete: 'Eliminar en Lote'
	},
	messages: {
		deleteConfirm: '¿Está seguro de que desea eliminar los {count} registros seleccionados?',
		deleteSuccess: 'Eliminación exitosa',
		selectDeleteWarning: 'Por favor seleccione registros para eliminar',
		operateSuccess: 'Operación exitosa',
		fileUploadSuccess: 'Carga de archivo exitosa',
		fileUploadError: 'Error en la carga del archivo',
		fileTypeError: '¡Solo se permiten formatos PDF y Word!',
		fileSizeError: '¡El tamaño del archivo no puede exceder 10MB!',
		generateReportSuccess: 'Informe generado exitosamente'
	},
	form: {
		orgId: 'Organización',
		reportName: 'Nombre del Informe',
		inspectDeviceReportId: 'Informe de Inspección Relacionado',
		author: 'Autor',
		reviewer: 'Revisor',
		approver: 'Aprobador',
		analysis: 'Análisis',
		advice: 'Consejo',
		adviceAttachment: 'Adjunto de Consejo',
		follow: 'Seguimiento',
		followAttachment: 'Adjunto de Seguimiento',
		warnInfo: 'Información de Advertencia',
		sensorDiagram: 'Diagrama del Sensor',
		installConfig: 'Configuración de Instalación',
		attachment: 'Carga de Adjunto',
		requiredFieldCannotBeEmpty: 'El campo obligatorio no puede estar vacío',
		add: 'Agregar',
		update: 'Actualizar',
		cancel: 'Cancelar',
		confirm: 'Confirmar',
		startDate: 'Fecha de Inicio',
		endDate: 'Fecha de Fin',
		fileUpload: 'Click para Subir'
	},
	table: {
		reportName: 'Nombre del Informe',
		fileName: 'Caso de Falla',
		inspectDeviceReportName: 'Informe de Inspección Relacionado',
		author: 'Autor',
		analysis: 'Análisis',
		advice: 'Consejo',
		createTime: 'Tiempo de Creación'
	},
	warnItem: {
		warnItem: 'Elemento de Advertencia',
		faultLocation: 'Ubicación de Falla',
		faultType: 'Tipo de Falla',
		selectFaultType: 'Por favor seleccione tipo de falla',
		warnLevel: 'Nivel de Advertencia',
		selectWarnLevel: 'Por favor seleccione nivel de advertencia',
		warnCount: 'Cantidad de Advertencias',
		diagnosisAnalysis: 'Análisis de Diagnóstico',
		enterDiagnosisAnalysis: 'Por favor ingrese análisis de diagnóstico',
		relatedAtlas: 'Atlas Relacionado',
		addAtlas: 'Agregar Atlas',
		diagnosisConclusion: 'Conclusión de Diagnóstico',
		enterDiagnosisConclusion: 'Por favor ingrese conclusión de diagnóstico',
		maintenanceSuggestion: 'Sugerencia de Mantenimiento',
		enterMaintenanceSuggestion: 'Por favor ingrese sugerencia de mantenimiento',
		warnStartTime: 'Tiempo de Inicio de Advertencia',
		warnEndTime: 'Tiempo de Fin de Advertencia',
		selectDateAndTime: 'Seleccionar fecha y hora'
	},
	vibrationData: {
		deviceName: 'Nombre del Dispositivo',
		sensorLoc: 'Ubicación del Sensor',
		axial: 'Dirección Axial',
		sensorType: 'Tipo de Sensor',
		enterDeviceName: 'Por favor ingrese nombre del dispositivo',
		enterSensorLoc: 'Por favor ingrese ubicación del sensor',
		enterAxial: 'Por favor ingrese dirección axial',
		enterSensorType: 'Por favor ingrese tipo de sensor',
		addVibrationData: 'Agregar Datos de Vibración'
	},
	placeholder: {
		selectOrg: 'Por favor seleccione organización',
		enterReportName: 'Por favor ingrese nombre del informe',
		selectInspectReport: 'Por favor seleccione informe de inspección relacionado',
		enterAuthor: 'Por favor ingrese autor',
		enterReviewer: 'Por favor ingrese revisor',
		enterApprover: 'Por favor ingrese aprobador',
		enterAnalysis: 'Por favor ingrese análisis',
		enterAdvice: 'Por favor ingrese consejo',
		enterFollow: 'Por favor ingrese seguimiento',
		fileUpload: 'Carga de Archivo'
	}
}
